import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import ShowCarsButton from '@/modules/CarsStock/components/Mobile/components/ShowCarsButton';
import { handleDeleteAllFilters } from '@/modules/CarsStock/components/common.helpers';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import { getStockBrandsAndModels } from '@/store/reducers/cars-stock';

import { MobileFiltersWrapper } from '../../../common.styles';

import ModelsFilter from './components/ModelsFilter';
import { FiltersProps } from './types';
import {
  ParamsFilterNew,
  ParamsFilterAmp,
  ParamsFilterElectric,
  ParamsFilterCommercial,
  ParamsFilterAll,
  ParamsFilterHybrid,
} from './components/ParamsFilter';

function Filters({ carsType }: FiltersProps) {
  const brandsAndModels = useTypedSelector(getStockBrandsAndModels);
  const dispatch = useTypedDispatch();
  const [isOpened, setOpened] = useState(false);

  const handleFiltersOpen = () => {
    setOpened(true);
  };

  const handleFiltersClose = () => {
    setOpened(false);
  };

  const handleFiltersClear = () => {
    handleDeleteAllFilters(dispatch, brandsAndModels);
  };

  return (
    <MobileFiltersWrapper>
      <StockMobileSidePanel
        title="Фильтры"
        isOutsideButton
        zIndex={10000}
        isOpened={isOpened}
        onOpen={handleFiltersOpen}
        onClose={handleFiltersClose}
        onDelete={handleFiltersClear}
      >
        <ModelsFilter carsType={carsType} />

        {carsType === 'new' ? (
          <ParamsFilterNew />
        ) : carsType === 'amp' ? (
          <ParamsFilterAmp />
        ) : carsType === 'electric' ? (
          <ParamsFilterElectric />
        ) : carsType === 'commercial' ? (
          <ParamsFilterCommercial />
        ) : carsType === 'hybrid' ? (
          <ParamsFilterHybrid />
        ) : (
          <ParamsFilterAll />
        )}

        <ShowCarsButton onClick={handleFiltersClose} />
      </StockMobileSidePanel>
    </MobileFiltersWrapper>
  );
}

export default Filters;
